export enum StateActiveDateElement {
    future,
    weekdays,
}
